import { createFileRoute } from "@tanstack/react-router";
import { useLanguage } from "@/i18n/LanguageProvider";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About — Code Cubs Academy" },
      {
        name: "description",
        content: "Our mission and vision: joyful, high-quality coding education for every child.",
      },
    ],
  }),
  component: AboutPage,
});

function AboutPage() {
  const { t } = useLanguage();
  return (
    <div>
      <section className="container mx-auto px-4 py-16 lg:py-24 text-center">
        <h1 className="text-4xl lg:text-6xl font-extrabold">{t.about.title}</h1>
        <p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto">{t.about.lead}</p>
      </section>

      <section className="container mx-auto px-4 grid md:grid-cols-2 gap-6 pb-16">
        <Card className="rounded-3xl border-0 shadow-soft">
          <CardContent className="p-8">
            <div className="text-5xl mb-4">🎯</div>
            <h2 className="font-extrabold text-2xl mb-2">{t.about.mission}</h2>
            <p className="text-muted-foreground">{t.about.missionText}</p>
          </CardContent>
        </Card>
        <Card className="rounded-3xl border-0 shadow-soft">
          <CardContent className="p-8">
            <div className="text-5xl mb-4">🌟</div>
            <h2 className="font-extrabold text-2xl mb-2">{t.about.vision}</h2>
            <p className="text-muted-foreground">{t.about.visionText}</p>
          </CardContent>
        </Card>
      </section>

      <section className="bg-muted/40 py-16">
        <div className="container mx-auto px-4 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {t.about.stats.map((s, i) => (
            <div key={i} className="text-center">
              <div className="text-4xl lg:text-5xl font-extrabold bg-gradient-primary bg-clip-text text-transparent">
                {s.n}
              </div>
              <div className="text-muted-foreground mt-1">{s.l}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
